import {Component} from '@angular/core';
import {BaseSubcomp} from '../../../base-subcomp';

@Component({
    selector: 'app-bot-subcomp-parent',
    templateUrl: './bot-subcomp-parent.component.html',
    styleUrls: ['./bot-subcomp-parent.component.scss'],
    standalone: false
})
export class BotSubcompParentComponent extends BaseSubcomp
{

}
